import { AppError, ErrorCode } from '../types';

export function fromNetworkError(err: any): AppError {
  const offline = typeof navigator !== 'undefined' && !navigator.onLine;
  return new AppError({
    code: offline ? ErrorCode.NET_OFFLINE : ErrorCode.NET_TIMEOUT,
    domain: 'network',
    cause: err,
  });
}
